import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  UserSummary,
  type UserSummaryConstructor,
  type UserSummaryRole,
} from './UserSummary'
import { RoleTypes } from '../enums/RoleTypeEnum'

export const UserSummaryRoleFactory = Factory.Sync.makeFactory<UserSummaryRole>(
  {
    name: Factory.each(() => faker.name.jobTitle()),
    type: Factory.each(() =>
      faker.random.arrayElement(Object.values(RoleTypes))
    ),
  }
)

export const UserSummaryConstructorFactory =
  Factory.Sync.makeFactory<UserSummaryConstructor>({
    id: Factory.each(() => faker.random.number()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    email: Factory.each(() => faker.internet.email()),
    profileImage: Factory.each(() => faker.internet.url()),
    role: Factory.each(() => UserSummaryRoleFactory.build()),
  })

export const UserSummaryFactory = EntityFactory(
  UserSummary,
  UserSummaryConstructorFactory
)
